(() => {
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-farm-upsell-select]');
    if (!select) return;

    const form = select.closest('form');
    const idInput = form?.querySelector('[data-farm-upsell-id]');
    if (idInput) idInput.value = select.value;

    const price = select.selectedOptions[0]?.dataset.price;
    const cardPrice = select.closest('.farm-cart-upsell-card')?.querySelector('.farm-cart-upsell-card__price');
    if (price && cardPrice) cardPrice.textContent = price;
  });

  document.addEventListener('click', (event) => {
    const previous = event.target.closest('[data-farm-upsell-prev]');
    const next = event.target.closest('[data-farm-upsell-next]');
    if (!previous && !next) return;

    const carousel = event.target.closest('[data-farm-upsell]');
    const viewport = carousel?.querySelector('[data-farm-upsell-viewport]');
    if (!viewport) return;

    viewport.scrollBy({
      left: (next ? 1 : -1) * viewport.clientWidth,
      behavior: 'smooth'
    });
  });
})();
